module.exports = __webpack_public_path__ + "img/house-of-change.fc48e5a5.jpg";